import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../../HeaderComponent';
import LoadingComponent from '../../LoadingComponent';
import OrderTable from './OrderTable';
import OrderRow from './OrderRow';

import css from '../../../styles/instrument/orders/orders';

class Orders extends Component {
    static propTypes = {
        isLoading: PropTypes.bool,
        orders: PropTypes.array,
        t: PropTypes.func.isRequired,
    }

    renderOrders() {
        const { orders } = this.props;

        const max = Math.max.apply(Math, orders.map(order =>
            Math.max(order.BIDVOL, order.ASKVOL)
        ));

        return orders.map((order, i) =>
            <OrderRow {...order} max={max} key={i} />
        );
    }

    renderContent() {
        if (!this.props.orders.length) {
            return <LoadingComponent height={255} />;
        }

        return (
            <div>
                <div className={css.tableWrapper}>
                    <OrderTable>
                        {this.renderOrders()}
                    </OrderTable>
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.isLoading && !this.props.orders.length) {
            return null;
        }

        return (
            <HeaderComponent title={this.props.t('orderSize')}>
                {this.renderContent()}
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Orders);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/orders/Orders.js
 **/